import { getZones } from '../services/zones.service';
import { SWITCH_SLICES } from '../components/store/slices/switchSlices';
import { systemOf } from '../constants/systems';

const zoneDevices = (zone) =>
  zone.specific_location
    ? zone.specific_location.flatMap(zoneDevices)
    : (zone.devices || []).map((device) => ({ zoneId: zone.zone_id, device }));

export const findZoneDevices = (zones, macs) =>
  zones
    .flatMap(zoneDevices)
    .filter(({ device }) => macs.includes(device.device_mac));

const applyServerCopy = (dispatch, updateDevice, devices) =>
  devices.forEach(({ zoneId, device }) =>
    dispatch(
      updateDevice({ data: { ...device, zoneInfo: { zone_id: zoneId } } }),
    ),
  );

export const resyncDevices = async (dispatch, system, macs) => {
  const zones = await getZones(system, { structured: true });

  applyServerCopy(dispatch, SWITCH_SLICES[systemOf(system).key].updateDevice, findZoneDevices(zones, macs));
};

// After the socket was down any device may have changed, so merge every
// device the server lists, the same way a socket push would. (A zone-list
// refetch would rebuild the whole switch slice and close open panels.)
export const resyncSystem = async (dispatch, system) => {
  const zones = await getZones(system, { structured: true });

  applyServerCopy(dispatch, SWITCH_SLICES[systemOf(system).key].updateDevice, zones.flatMap(zoneDevices));
};
